"use strict";

/*  ------------------ ICE Calculations ------------------ */

function getIceSymbol(month) {
  switch (month) {
    case 0:
      return "/GAS";
    case 1:
      return "/GAS<1>";
    case 2:
      return "/GAS<2>";
  }
}

/*  ------------------ Product Calculations ------------------ */

function calculateFlatPrice(priceUSD, fx, lpt, duty) {
  // Formula: (Price (USD)/FX)/Density + Duty
  const densityLitresPerTonne = convertDensityToLitresPerTonne(lpt);
  return Number(priceUSD / fx / densityLitresPerTonne + duty);
}

function calculateBlendedFlatPrice(bioBlend, flatPrice_product_1, flatPrice_product_2) {
  // Formula: Bio-blend % * Flat Price for Product 1 + (1 - Bio-blend %) * Flat Price for Product 2
  return Number(bioBlend * flatPrice_product_1 + (1 - bioBlend) * flatPrice_product_2);
}

function calculateUsdDifferential(productSettlementUsd, iceSettlement) {
  return productSettlementUsd - iceSettlement;
}

function marketChangePpl(settlePpl, livePpl) {
  return livePpl - settlePpl;
}

function calculateLivePrice(flatPrice, marketChange) {
  return Number(flatPrice + marketChange);
}

function calculateStaOnDuty(staCorrectionFactor, duty, density, settleFx) {
  const densityLitresPerTonne = convertDensityToLitresPerTonne(density);
  const staFactor = staCorrectionFactor - 1;
  return staFactor * duty * densityLitresPerTonne * settleFx;
}

function calculateStaOnProduct(liveIce, usdDiff, staCorrectionFactor) {
  const staFactor = staCorrectionFactor - 1;
  return (liveIce + usdDiff) * staFactor;
}

function staUsdPerMetricTonne(staOnDuty, staOnProduct) {
  return staOnDuty + staOnProduct;
}

function staPpl(staOnDuty, staOnProduct, settleFx, density) {
  return ((staOnDuty + staOnProduct) / settleFx / density) * 100;
}

function getStaCorrectionFactor(temperature, productId, staMatrix) {
  const staObject = staMatrix.find((sta) => sta.temperature === temperature);
  return staObject ? staObject[productId] : 1;
}

/*  ------------------ Measurement Conversions ------------------ */

function usdPerTonneToPpl(value, settleFx, density) {
  const densityLitresPerTonne = convertDensityToLitresPerTonne(density);
  return value / settleFx / densityLitresPerTonne;
}

function bioRuleUsdPerTonneToPpl(value, settleFx, density, bioBlend) {
  //Calculation: rule value / FX settlement / biodiesel density * 100 * RTFO bio percentage
  return (((value / density) * 100) / settleFx) * (bioBlend / 100);
}

function bioRulePpl(value, bioBlend) {
  return (value * bioBlend) / 100;
}

function convertDensityToLitresPerTonne(density) {
  return density / 100;
}

export {
  getIceSymbol,
  calculateFlatPrice,
  calculateBlendedFlatPrice,
  calculateUsdDifferential,
  marketChangePpl,
  calculateLivePrice,
  usdPerTonneToPpl,
  bioRuleUsdPerTonneToPpl,
  bioRulePpl,
  calculateStaOnDuty,
  calculateStaOnProduct,
  staUsdPerMetricTonne,
  staPpl,
  getStaCorrectionFactor,
};
